import MainLayout from './MainLayout/MainLayoutConfig';

const NexusLayoutConfigs = {
  MainLayout,
};

export default NexusLayoutConfigs;
